<template>
  <header class="app-nav">
    <RouterLink to="/" class="nav-brand">
      <span class="wordmark">tykkets</span><span class="stamp">UK</span>
    </RouterLink>
    <NotificationBell />
  </header>
</template>

<script setup lang="ts">
import NotificationBell from '../ui/NotificationBell.vue'
</script>

<style scoped>
.app-nav {
  position: sticky;
  top: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 52px;
  background: var(--paper);
  border-bottom: 1px solid var(--rule);
  isolation: isolate;
}
.nav-brand {
  display: inline-flex;
  align-items: center;
  gap: .45rem;
  text-decoration: none;
  line-height: 1;
}
.wordmark {
  font-family: var(--sans);
  font-weight: 800;
  font-size: 1.6rem;
  letter-spacing: -.035em;
  color: var(--ink);
}
.stamp {
  font-family: var(--sans);
  font-size: .6rem;
  font-weight: 700;
  letter-spacing: .16em;
  text-transform: uppercase;
  color: var(--accent);
  border: 1.5px solid var(--accent);
  padding: .18rem .42rem;
  line-height: 1;
  align-self: center;
}
.nav-brand:hover .wordmark { color: var(--accent); }
.nav-brand:hover .stamp { background: var(--accent); color: var(--paper); }
</style>
